module.exports = __webpack_public_path__ + "static/img/6.44f9cff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/6.png
// module id = q+AO
// module chunks = 0